export const getSortFieldAndDirection = (
	sortByFromUserPrefs: string | number | boolean | undefined,
) => {
	const [sortField, sortDirection] =
		typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
	if (!sortField || (sortDirection !== 'ASC' && sortDirection !== 'DESC')) {
		return {};
	}
	return {
		sortField,
		sortDirection,
	} as const;
};
